import { useColorModeValue as mode, Input, Stack, FormControl, FormHelperText, FormLabel, FormErrorMessage } from '@chakra-ui/react'
import { Field, FormikProps } from 'formik';
import * as React from 'react'

import { IApiTradeEditRequest } from '../../../models/api/trade/IApiTradeEditRequest';
import { InputFormControl } from '../../formcontrols/InputFormControl';
import { IBaseDrawerProps } from '../BaseDrawer';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';

export interface IEditTradeDrawerProps extends Omit<IBaseDrawerProps<IApiTradeEditRequest>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText" | "isOpen"> {
    defaultValue: IApiTradeEditRequest | undefined;
}

export const EditTradeDrawer = (props: IEditTradeDrawerProps) => {
    return (
        <BaseDrawerWithForm
            isOpen={props.defaultValue !== undefined}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue}
            headerText="Projekt bearbeiten"
        >
            {({ handleSubmit, errors, touched, isSubmitting }: FormikProps<IApiTradeEditRequest>) => (
                <Stack px="0" spacing="4">
                    <InputFormControl 
                        field="value"
                        label="Bezeichnung"
                        isInvalid={(errors.value && touched.value) ? true : false}
                        isDisabled={isSubmitting}
                        validate={(value: string) => {
                            let error;
                            if (value === null || value === undefined || value.length < 1) {
                                error = "Bezeichnung ist erforderlich!";
                            }
                            return error;
                        }}
                        errorMessage={errors.value}
                    />
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}